import ChevronRight from '@mui/icons-material/ChevronRightRounded';
import PersonSearchIcon from '@mui/icons-material/PersonSearchRounded';
import { Box, ButtonBase, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DisplayType, useGetLiveSessionQuery } from '../../../../../generated/core-api/graphql-react-query';
import useDisplay from '../../../../Contexts/GlobalContext/Hooks/useDisplay';
import useSessionContext from '../../../../LiveContext/SessionContextProvider/useSessionContext';
import DetectionList from './Components/DetectionList';
import StyledBox from './styles';

export default function HistoryPanel() {
  const { session: basicSessionInfo } = useSessionContext();
  const session = useGetLiveSessionQuery({ input: { id: basicSessionInfo?.id ?? '' } }, { enabled: !!basicSessionInfo });
  const { t } = useTranslation();
  const hasClient = session.data?.getSession.externalCall?.clientCard?.id;
  const display = useDisplay();

  return (
    <StyledBox>
      {hasClient && (
        <Box className="clientCard">
          <Typography variant="subtitle1">
            <PersonSearchIcon />
            {t('detections.client')}
          </Typography>
          <ButtonBase
            onClick={() => {
              display(session.data?.getSession.externalCall?.clientCard?.id, DisplayType.ClientDisplay);
            }}
          >
            {session.data?.getSession.externalCall?.clientCard?.title}
            <ChevronRight />
          </ButtonBase>
        </Box>
      )}
      <DetectionList />
    </StyledBox>
  );
}
